import { hasRoute } from '../utils';
import { routes } from '../routes';

const logAndRet = (returnValue) => {console.log(returnValue); return returnValue}
const isSearchRoute = (active_routes) => hasRoute(active_routes, routes['search'])
const isPlaceRoute = (active_routes) => hasRoute(active_routes, routes['place'])
const isPlaceReviewRoute = (location) => location && 'reviewing' in location.query
const isPanelView = (active_routes) => isSearchRoute(active_routes) || isPlaceRoute(active_routes)

const getNavPosition = (browser, route, location?) => {
	if (browser.lessThan.small) return 'bottom'
	if (isPlaceReviewRoute(location) && browser.lessThan.placeReviewViewLimit) return null
	if ((isSearchRoute(route) || (isPlaceRoute(route) && !isPlaceReviewRoute(location))) && browser.lessThan.searchViewLimit) return 'bottom'
	if (isPanelView(route)) return 'floating'
	if (browser.lessThan.searchViewLimit) return 'bottom'
	return 'header'
}
// logAndRet(
// 	(
// 	 ||
// 	 || browser.lessThan.small) ? 'mobile' : 'header'
// )

export { isSearchRoute, isPlaceRoute, isPanelView, getNavPosition };



// WEBPACK FOOTER //
// ./src/app/Layouts/utils.ts